<div class="modal-header">
  <h4 class="modal-title">Actualizar: {{usuario}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="datosForm">
    <div class="row">
      <div class="col-12">
        <div class="form-group position-relative">
          <label for="inputPassword">Contraseña</label>
          <input [type]="seePass ? 'text' : 'password'" class="form-control" id="inputPassword"
            aria-describedby="passwordHelp"
            [ngClass]="{'is-invalid':GetContraseniaControl()?.errors && GetContraseniaControl()?.dirty}"
            placeholder="Contraseña" formControlName="contrasenia">
          <span class="material-icons update-icon see-icon" (click)="seePass = !seePass">
            {{seePass ? 'visibility_off' : 'visibility'}}</span>
          <div *ngIf="GetContraseniaControl()?.hasError('required') && GetContraseniaControl()?.dirty"
            class="invalid-feedback">
            La contraseña es requerida.
          </div>
          <small id="inputDni" class="form-text text-danger" *ngIf="datosForm.controls['contrasenia'].hasError('pattern')">
            La contraseña debe tener mínimo 8 caracteres , una letra mayúscula, una letra minúscula  , un número y un caracter especial.
          </small>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group position-relative">
          <label for="inputPasswordConfirm">Confirmar Contraseña</label>
          <input [type]="seePassConfirm ? 'text' : 'password'" class="form-control" id="PasswordConfirm"
            aria-describedby="passwordConfirmHelp" [ngClass]="{'is-invalid': datosForm.hasError('notSame')}"
            placeholder="Confirmar Contraseña" formControlName="contraseniaConfirmar">
          <span class="material-icons update-icon see-icon" (click)="seePassConfirm = !seePassConfirm">
            {{seePassConfirm ? 'visibility_off' : 'visibility'}}</span>
          <div class="invalid-feedback" *ngIf="datosForm.hasError('notSame')">
            Las contraseñas deben ser iguales.
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-danger" (click)="Cancelar()">Cancelar</button>
  <button type="button" class="btn btn-outline-primary" (click)="Aceptar()"
    [disabled]="datosForm.invalid">Aceptar</button>
</div>
